import { Divider, Icon, Modal, Table, Tooltip } from "antd";
import axios from "axios";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";

import {
  DELETE_MED_FROM_INVENTORY,
  EDIT_MED_TO_INVENTORY,
} from "../../ActionTypes/ActionTypes";
import AddMedInfoModal from "./AddMedInfoModal";

const { Column } = Table;
const { confirm } = Modal;

class InventorisedMeds extends Component {
  state = {
    loading: false,
    visibleInventoryModalEdit: false,
    selectedMedEdit: {},
  };

  showInventoryModalEdit = (med_id) => {
    const { inventorized_meds } = this.props;

    // console.log(med_id);

    const selected_med = inventorized_meds.filter((med) => med.id === med_id);
    this.setState({
      visibleInventoryModalEdit: true,
      selectedMedEdit: selected_med[0],
    });
  };

  deleteInventorisedMedEdit = (med_id) => {
    const { patient_packet, deleteMedFromInventory } = this.props;

    if (patient_packet === "") {
      // console.log('run this');
      deleteMedFromInventory(med_id);
    } else {
      // console.log('run axios');
      axios({
        method: "delete",
        url: `/medicine_strips/${med_id}.json`,
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
      }).then(() => {
        deleteMedFromInventory(med_id);
      });
    }
  };

  hideInventoryModalEdit = async () => {
    await this.setState({
      visibleInventoryModalEdit: false,
      selectedMedEdit: {},
    });
  };

  saveFormMedInfoEdit = (formRef) => {
    this.formMedInfoEdit = formRef;
  };

  handleMedEditSubmit = () => {
    const { form } = this.formMedInfoEdit.props;
    const {
      inventorized_meds,
      requisition_meds,
      editMedToInventory,
      patient_packet,
    } = this.props;
    const { selectedMedEdit } = this.state;

    form.validateFields((err, values) => {
      if (err) {
        // console.log(err);
        return;
      }

      if (values.exp_available === "false") {
        values.expiry_date = null;
      }

      if (values.batch_available === "false") {
        values.batch_number = null;
      }

      // delete unused attribute
      delete values.exp_available;
      delete values.batch_available;

      const indexId = inventorized_meds.indexOf(selectedMedEdit);
      values.expiry_date = moment(values.expiry_date).format("YYYY-M-D");
      values.prescription_medicine_id =
        selectedMedEdit.prescription_medicine_id;
      values.total_quantity = requisition_meds.filter(
        (med) =>
          Number(med.id) === Number(selectedMedEdit.prescription_medicine_id)
      )[0].total_quantity;

      // console.log(values);

      if (patient_packet === "") {
        editMedToInventory(indexId, values);
        this.hideInventoryModalEdit();
      } else {
        delete values.name;
        axios({
          method: "put",
          url: `/medicine_strips/${selectedMedEdit.id}.json`,
          headers: { Authorization: sessionStorage.getItem("jwtToken") },
          data: {
            medicine_strip: values,
          },
        }).then((response) => {
          // console.log(response.data);
          editMedToInventory(indexId, response.data);
          this.hideInventoryModalEdit();
          window.location.reload();
        });
      }
    });
  };

  showDeleteConfirm = (id) => {
    confirm({
      title: "Are you sure?",
      content: "This medicine will be deleted.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: () => {
        this.deleteInventorisedMedEdit(id);
      },
      onCancel: () => {
        console.log("Cancel");
      },
    });
  };

  render() {
    const { loading, visibleInventoryModalEdit, selectedMedEdit } = this.state;
    const { partnersList } = this.props;
    const { inventorized_meds } = this.props;

    return (
      <div>
        <Table
          dataSource={inventorized_meds}
          pagination={false}
          loading={loading}
          bordered
          size="middle"
          rowKey="id"
        >
          <Column title="Name" align="center" dataIndex="name" />

          <Column
            title="Source"
            align="center"
            render={(record) => {
              const ptnr = partnersList.filter(
                (partner) =>
                  Number(partner.id) === Number(record.partner_location_id)
              )[0];
              return ptnr == null ? "" : ptnr.name;
            }}
          />

          <Column title="Expiry" align="center" dataIndex="expiry_date" />

          <Column title="Pills" align="center" dataIndex="num_pills" />

          <Column
            title="Actions"
            align="center"
            render={(record) => (
              <span>
                <Tooltip placement="top" title="Edit">
                  <Icon
                    type="edit"
                    onClick={() => this.showInventoryModalEdit(record.id)}
                    theme="twoTone"
                    twoToneColor="blue"
                    style={{ fontSize: "20px", cursor: "pointer" }}
                  />
                </Tooltip>

                <Divider type="vertical" />

                <Tooltip placement="top" title="Delete">
                  <Icon
                    type="delete"
                    onClick={() => this.showDeleteConfirm(record.id)}
                    theme="twoTone"
                    twoToneColor="red"
                    style={{ fontSize: "20px", cursor: "pointer" }}
                  />
                </Tooltip>
              </span>
            )}
          />
        </Table>

        <AddMedInfoModal
          wrappedComponentRef={this.saveFormMedInfoEdit}
          partnersList={partnersList}
          onCreate={this.handleMedEditSubmit}
          visible={visibleInventoryModalEdit}
          onCancel={this.hideInventoryModalEdit}
          data={selectedMedEdit}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  orders: state.InventoryState.orders,
  requisition_meds: state.InventoryState.requisition_medicines,
  inventorized_meds: state.InventoryState.inventorized_medicines,
  patient_packet: state.InventoryState.patient_packet,
  partnersList: state.InventoryState.partners_list,
});

const mapDispatchToProps = (dispatch) => ({
  editMedToInventory: (position, data) =>
    dispatch({
      type: EDIT_MED_TO_INVENTORY,
      payload: { id: position, meds: data },
    }),
  deleteMedFromInventory: (med_id) =>
    dispatch({ type: DELETE_MED_FROM_INVENTORY, payload: { id: med_id } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(InventorisedMeds);



// WEBPACK FOOTER //
// ./src/component/Inventory/InventorisedMeds.js